import DashboardBannerCreate from "./dashboardBannerCreate";
import DashboardBannerEdit from "./dashboardBannerEdit";
import DashboardBannerList from "./dashboardBannerList";

export default {
  create: DashboardBannerCreate,
  list: DashboardBannerList,
  edit: DashboardBannerEdit,
};
